module.exports = __webpack_public_path__ + "static/media/General-Construction.73074bbf.jpg";